import clsx from "clsx";

import { Row } from "@/components/Row";
import { SelectContent, SelectItem } from "@/components/ui/select";

import {
  candidacyStatusOptions,
  candidacyStatusToBackgroundColor,
} from "@/lib/constants";

export const CandidacyStatusSelectContent = () => {
  return (
    <SelectContent>
      {candidacyStatusOptions.map((option) => (
        <SelectItem key={option.value} value={option.value}>
          <Row className="items-center gap-2">
            <div
              className={clsx(
                "h-3 w-3 rounded-full",
                candidacyStatusToBackgroundColor[option.value],
              )}
            />
            {option.label}
          </Row>
        </SelectItem>
      ))}
    </SelectContent>
  );
};
